module.exports = __webpack_public_path__ + "img/logo.25a84a00.png";